/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  NameServiceRefStorage,
  NameServiceRefStorageInterface,
} from "../../../contracts/nameServiceRef/NameServiceRefStorage";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "nameService_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
] as const;

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060405160c838038060c8833981016040819052602a91604e565b600080546001600160a01b0319166001600160a01b0392909216919091179055607c565b600060208284031215605f57600080fd5b81516001600160a01b0381168114607557600080fd5b9392505050565b603f8060896000396000f3fe6080604052600080fdfea2646970667358221220794a3a69a18377211db7a381fb9b69945d9a9486a1e9ff56c805c5e8438027d364736f6c63430008110033";

type NameServiceRefStorageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NameServiceRefStorageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NameServiceRefStorage__factory extends ContractFactory {
  constructor(...args: NameServiceRefStorageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    nameService_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<NameServiceRefStorage> {
    return super.deploy(
      nameService_,
      overrides || {}
    ) as Promise<NameServiceRefStorage>;
  }
  override getDeployTransaction(
    nameService_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(nameService_, overrides || {});
  }
  override attach(address: string): NameServiceRefStorage {
    return super.attach(address) as NameServiceRefStorage;
  }
  override connect(signer: Signer): NameServiceRefStorage__factory {
    return super.connect(signer) as NameServiceRefStorage__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NameServiceRefStorageInterface {
    return new utils.Interface(_abi) as NameServiceRefStorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NameServiceRefStorage {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NameServiceRefStorage;
  }
}
